<template>
  <div>
    <div v-if="isPreview == 1">
      <!-- 预览 -->
      <applyEnrollCheck
        v-if="isPreview == 1"
        @backPreview="backPreview"
        @onSubmitDz="onSubmitDz"
        :form="form"
        :address="address"
        :formList="formList"
        :applyNumber="applyNumber"
        :appliedShow="appliedShow"
        :piclink="piclink"
        :cardpositive="cardpositive"
        :cardnegative="cardnegative"
        :diploma="diploma"
        :skills_certificate="skills_certificate"
        :other_certificate="other_certificate"
      ></applyEnrollCheck>
    </div>
    <div class="applyForm" v-else>
      <!-- 填写 -->
      <van-nav-bar
        title="报名信息写入"
        left-arrow
        @click-left="$router.go(-1)"
        placeholder
        fixed
        safe-area-inset-top
      />

      <div v-if="form.id">
        <van-notice-bar
          v-if="form.first_instance == 0"
          text="初审情况：审核中"
        />
        <van-notice-bar
          v-else-if="form.first_instance == 1"
          text="初审情况：通过"
          color="#1989fa"
          background="#ecf9ff"
        />
        <van-notice-bar
          v-else-if="form.first_instance == 2"
          color="#ee0a24"
          background="#f1d9dc"
          text="初审情况：不通过"
        />
        <van-notice-bar
          v-else-if="form.first_instance == 3"
          color="#ee0a24"
          background="#f1d9dc"
          text="初审情况：资料不齐"
        />
      </div>

      <div class="form_content">
        <van-form
          @submit="onSubmit"
          ref="formRef"
          label-width="120px"
          scroll-to-error
        >
          <van-field
            :disabled="!showBtn"
            v-model="form.tel"
            center
            clearable
            label="手机号"
            placeholder="请输入手机号"
            :rules="[
              { validator: validatorTel, message: '请输入合法手机号码' },
            ]"
            input-align="right"
          >
            <!-- <template #button>
            <van-button size="small" type="primary">发送验证码</van-button>
          </template> -->
          </van-field>

          <van-field
            :disabled="!showBtn"
            input-align="right"
            v-model="form.name"
            name="姓名"
            label="姓名"
            placeholder="姓名"
            :rules="[{ required: true, message: '姓名' }]"
            error-message-align="right"
          />
          <van-field
            :disabled="!showBtn"
            readonly
            clickable
            input-align="right"
            name="picker"
            :value="form.sex"
            label="性别"
            placeholder="请选择性别"
            @click="openPicker('sex')"
            :rules="[{ required: 'onChange', message: '请选择性别' }]"
          />
          <van-field
            :disabled="!showBtn"
            name="uploader"
            label=""
            input-align="right"
            :rules="[{ required: 'onChange', message: '请上传标准证件照' }]"
          >
            <template #label>
              <span
                >上传标准证件照（须上传本人近期正面白底免冠电子证件照片，照片须清晰。）</span
              >
            </template>
            <template #input>
              <van-uploader
                :disabled="!showBtn"
                v-model="piclink"
                @delete="
                  (e, detail) => {
                    delImg(e, detail, 'piclink');
                  }
                "
                :after-read="
                  (e) => {
                    afterRead(e, 'piclink');
                  }
                "
                :max-count="1"
              />
            </template>
          </van-field>

          <van-field
            name="uploader"
            label="身份证正面"
            input-align="right"
            :rules="[{ required: 'onChange', message: '请上传身份证正面' }]"
            :disabled="!showBtn"
          >
            <template #input>
              <van-uploader
                :disabled="!showBtn"
                v-model="cardpositive"
                @delete="
                  (e, detail) => {
                    delImg(e, detail, 'cardpositive');
                  }
                "
                :after-read="
                  (e) => {
                    afterRead(e, 'cardpositive');
                  }
                "
                :max-count="1"
              />
            </template>
          </van-field>
          <van-field
            :disabled="!showBtn"
            name="uploader"
            label="身份证反面"
            input-align="right"
            :rules="[{ required: 'onChange', message: '请上传身份证反面' }]"
          >
            <template #input>
              <van-uploader
                :disabled="!showBtn"
                v-model="cardnegative"
                @delete="
                  (e, detail) => {
                    delImg(e, 'cardnegative');
                  }
                "
                :after-read="
                  (e) => {
                    afterRead(e, 'cardnegative');
                  }
                "
                :max-count="1"
              />
            </template>
          </van-field>

          <van-field
            :disabled="!showBtn"
            readonly
            clickable
            input-align="right"
            name="picker"
            :value="form.political_status"
            label="政治面貌"
            placeholder="请选择政治面貌"
            @click="openPicker('political_status')"
            :rules="[{ required: 'onChange', message: '请选择政治面貌' }]"
          />
          <van-field
            :disabled="!showBtn"
            input-align="right"
            v-model="form.nation"
            name="民族"
            label="民族"
            placeholder="民族"
            :rules="[{ required: true, message: '请填写民族' }]"
          />
          <van-field
            :disabled="!showBtn"
            readonly
            clickable
            input-align="right"
            name="picker"
            :value="form.native_place"
            label="籍贯"
            placeholder="请选择籍贯"
            @click="openAddress('native_place')"
            :rules="[{ required: 'onChange', message: '请选择籍贯' }]"
          />
          <van-field
            :disabled="!showBtn"
            readonly
            clickable
            input-align="right"
            name="picker"
            :value="form.birthplace"
            label="生源地"
            placeholder="请选择生源地"
            @click="openAddress('birthplace')"
            :rules="[{ required: 'onChange', message: '请选择生源地' }]"
          />
          <van-field
            :disabled="!showBtn"
            readonly
            clickable
            input-align="right"
            name="picker"
            :value="form.domicile"
            label="户籍地"
            placeholder="请选择户籍地"
            @click="openAddress('domicile')"
            :rules="[{ required: 'onChange', message: '请选择户籍地' }]"
          />
          <van-field
            :disabled="!showBtn"
            readonly
            clickable
            input-align="right"
            v-model="form.marital_status"
            name="picker"
            :value="form.marital_status"
            label="婚姻状况"
            placeholder="请选择婚姻状况"
            @click="openPicker('marital_status')"
            :rules="[{ required: 'onChange', message: '请选择婚姻状况' }]"
          />
          <van-field
            :disabled="!showBtn"
            input-align="right"
            v-model="form.graduated_school"
            name="毕业院校"
            label="毕业院校"
            placeholder="请输入毕业院校"
            :rules="[{ required: true, message: '毕业院校' }]"
          />
          <van-field
            :disabled="!showBtn"
            input-align="right"
            :value="$fnc.getTimeFormat(form.graduated_school_time, 'ymd')"
            name="毕业时间"
            label="毕业时间"
            placeholder="请选择毕业时间"
            @click="openPicker('毕业时间')"
          />
          <van-field
            :disabled="!showBtn"
            readonly
            clickable
            input-align="right"
            name="picker"
            :value="form.edu"
            label="学历"
            placeholder="请选择学历"
            @click="openPicker('edu')"
            :rules="[{ required: 'onChange', message: '请选择学历' }]"
          />
          <van-field
            :disabled="!showBtn"
            readonly
            clickable
            input-align="right"
            name="picker"
            :value="
              form.card_type && form.card_type == '0'
                ? '国内身份证'
                : form.card_type && form.card_type == '1'
                ? '香港身份证'
                : '澳门身份证'
            "
            label="证件类型"
            placeholder="请选择证件类型"
            @click="openPicker('card_type')"
            suffixIcon="arrow-right"
            suffixIconStyle="color:#999;font-size:26rpx;"
          />

          <div v-if="form.card_type && form.card_type != '0'">
            <van-field
              :disabled="!showBtn"
              input-align="right"
              v-model="form.id_card"
              :name="
                form.card_type && form.card_type == '1'
                  ? '香港身份证'
                  : '澳门身份证'
              "
              :label="
                form.card_type && form.card_type == '1'
                  ? '香港身份证'
                  : '澳门身份证'
              "
              placeholder="港澳身份证"
              error-message-align="right"
              :rules="[{ required: true, message: '请输入身份证号' }]"
            />
            <van-field
              :disabled="!showBtn"
              readonly
              clickable
              name="datetimePicker"
              :value="form.birth"
              @click="openPicker('出生日期')"
              label="出生日期"
              placeholder="请选择出生日期"
              input-align="right"
            />
          </div>
          <div v-else>
            <van-field
              :disabled="!showBtn"
              v-if="form.card_type && form.card_type == '0'"
              type="text"
              input-align="right"
              v-model="form.id_card"
              name="国内身份证号"
              label="国内身份证号"
              placeholder="国内身份证号"
              @blur="getAgeValue"
              :rules="[
                { validator: validatorCard, message: '请输入合法身份证号' },
                {
                  validator: validatorCard1,
                  message:
                    '根据招聘要求本科生出生日期1988年8月1日（含）后才可以报名',
                },
                {
                  validator: validatorCard2,
                  message:
                    '根据招聘要求研究生出生日期1986年8月1日（含）后才可以报名',
                },
                {
                  validator: validatorCard3,
                  message:
                    '根据招聘要求博士生出生日期1981年8月1日（含）后才可以报名',
                },
              ]"
            />
            <van-field
              :disabled="!showBtn"
              readonly
              clickable
              name="datetimePicker"
              :value="form.birth"
              label="出生日期"
              placeholder="请选择出生日期"
              input-align="right"
              :rules="[{ required: 'onChange', message: '请选择出生日期' }]"
            />
          </div>

          <van-field
            :disabled="!showBtn"
            type="text"
            input-align="right"
            v-model="form.age"
            name="年龄"
            label="年龄"
            placeholder="年龄"
            readonly
            :rules="[{ required: true, message: '请输入年龄' }]"
          />

          <van-field
            :disabled="!showBtn"
            readonly
            clickable
            input-align="right"
            name="picker"
            :value="address"
            label="家庭地址"
            placeholder="请选择家庭地址"
            @click="openAddress('')"
            :rules="[{ required: 'onChange', message: '请选择家庭地址' }]"
          />
          <van-field
            :disabled="!showBtn"
            input-align="right"
            v-model="form.address"
            name="详细地址"
            label="详细地址"
            placeholder="请输入详细地址"
            :rules="[{ required: true, message: '详细地址' }]"
          />

          <!-- <van-field
          name="uploader"
          label="上传学历证书"
          input-align="right"
          :rules="[{ required: 'onChange', message: '上传学历证书' }]"
        >
          <template #input>
            <van-uploader
              v-model="diploma"
              @delete="
                (e, detail) => {
                  delImg(e, 'diploma');
                }
              "
              :after-read="
                (e) => {
                  afterRead(e, 'diploma');
                }
              "
              :max-count="1"
            />
          </template>
        </van-field> -->

          <van-field
            :disabled="!showBtn"
            name="uploader"
            label="上传学历证书"
            input-align="right"
            :rules="diplomaRules"
          >
            <template #input>
              <van-uploader
                :disabled="!showBtn"
                v-model="diploma"
                @delete="
                  (e, detail) => {
                    delImg(e, detail, 'diploma');
                  }
                "
                :after-read="
                  (e) => {
                    afterReadList(e, 'diploma');
                  }
                "
                multiple
              />
            </template>
          </van-field>

          <van-field
            :disabled="!showBtn"
            input-align="right"
            v-model="form.current_title"
            name="现有职称"
            label="现有职称"
            placeholder="现有职称"
            :rules="[{ required: true, message: '现有职称' }]"
            error-message-align="right"
            autosize
            type="textarea"
          />
          <van-field
            :disabled="!showBtn"
            input-align="right"
            v-model="form.current_professional_certification"
            name="现有从业资格证书、等级"
            label="现有从业资格证书、等级"
            placeholder=" 现有从业资格证书、等级"
            :rules="[{ required: true, message: ' 现有从业资格证书、等级' }]"
            error-message-align="right"
            autosize
            type="textarea"
          />

          <van-field
            :disabled="!showBtn"
            readonly
            clickable
            input-align="right"
            name="picker"
            :value="form.a_city"
            label="报考城市"
            placeholder="请选择报考城市"
            :rules="[{ required: 'onChange', message: '请选择报考城市' }]"
          />
          <!-- @click="openPicker('a_city')" -->
          <van-field
            :disabled="!showBtn"
            readonly
            clickable
            input-align="right"
            name="picker"
            :value="form.position_applied"
            :label="
              '报考岗位' +
              (form.position_applied && form.a_city && appliedShow == 1
                ? `  报考人数： ${applyNumber}`
                : '')
            "
            placeholder="请选择报考岗位"
            @click="openPosition"
            label-width="160px"
            :rules="[{ required: 'onChange', message: '请选择报考岗位' }]"
          />
          <!-- <van-field
            v-show="form.position_applied && form.position_applied != ''"
            disabled
            readonly
            clickable
            input-align="right"
            name="picker"
            :value="form.position_no"
            placeholder="请选择报考岗位"
            label="报考岗位代码"
            label-width="160px"
          /> -->

          <van-field
            :disabled="!showBtn"
            readonly
            clickable
            input-align="right"
            name="picker"
            :value="form.right_major"
            label="对口专业"
            placeholder="请选择对口专业"
            @click="openMajor"
            :rules="[{ required: 'onChange', message: '请选择对口专业' }]"
          />

          <van-field
            :disabled="!showBtn"
            readonly
            clickable
            input-align="right"
            name="picker"
            :value="form.specific_skill"
            label="专业技能"
            placeholder="请选择专业技能"
            @click="openPicker('specific_skill')"
            :rules="[{ required: 'onChange', message: '请选择专业技能' }]"
          />
          <!-- <van-field name="checkboxGroup">
          <template #input>
            <van-checkbox v-model="is_checked"></van-checkbox>
            <span style="margin-left: 10px; color: blue" @click="showTxt = true"
              >承诺书</span
            >
          </template>
        </van-field> -->
          <template v-for="(item, i) in formList">
            <template>
              <van-field
                :disabled="!showBtn"
                input-align="right"
                v-model="item.yx"
                :name="'yx'"
                :label="item.label + '院校'"
                :placeholder="`请输入${item.label}院校`"
                :rules="[
                  { required: true, message: `请输入${item.label}院校` },
                ]"
                error-message-align="right"
                :key="i + Math.random() * 100"
              />
              <van-field
                :disabled="!showBtn"
                input-align="right"
                v-model="item.zy"
                :name="'zy'"
                :label="item.label + '专业'"
                :placeholder="`请输入${item.label}专业`"
                :rules="[
                  { required: true, message: `请输入${item.label}专业` },
                ]"
                error-message-align="right"
                :key="i + Math.random() * 100"
              />
              <van-field
                input-align="right"
                v-model="item.xw"
                :name="'xw'"
                :label="item.label + '学位'"
                :placeholder="`请输入${item.label}学位`"
                :rules="[
                  { required: true, message: `请输入${item.label}学位` },
                ]"
                error-message-align="right"
                :key="i + Math.random() * 100"
              />
            </template>
          </template>

          <van-field
            :disabled="!showBtn"
            input-align="right"
            v-model="form.work_experience"
            name="学习和工作经历"
            label="学习和工作经历"
            placeholder="学习和工作经历"
            :rules="[{ required: true, message: '学习和工作经历' }]"
            error-message-align="right"
            autosize
            type="textarea"
          />
          <van-field
            :disabled="!showBtn"
            input-align="right"
            v-model="form.family_member"
            name="家庭成员"
            label="家庭成员"
            placeholder="家庭成员"
            :rules="[{ required: true, message: '家庭成员' }]"
            error-message-align="right"
            autosize
            type="textarea"
          />
          <van-field
            :disabled="!showBtn"
            name="uploader"
            label="上传技能证书"
            input-align="right"
            :rules="skills_certificateRules"
          >
            <template #input>
              <van-uploader
                :disabled="!showBtn"
                v-model="skills_certificate"
                @delete="
                  (e, detail) => {
                    delImg(e, detail, 'skills_certificate');
                  }
                "
                :after-read="
                  (e) => {
                    afterReadList(e, 'skills_certificate');
                  }
                "
                multiple
              />
            </template>
          </van-field>
          <van-field
            :disabled="!showBtn"
            name="uploader"
            label="上传其他证书"
            input-align="right"
          >
            <template #input>
              <van-uploader
                :disabled="!showBtn"
                v-model="other_certificate"
                @delete="
                  (e, detail) => {
                    delImg(e, detail, 'other_certificate');
                  }
                "
                :after-read="
                  (e) => {
                    afterReadList(e, 'other_certificate');
                  }
                "
                multiple
              />
            </template>
          </van-field>
          <!-- <van-field
          name="uploader"
          label="上传简历"
          input-align="right"
          :rules="[{ required: 'onChange', message: '请上传简历' }]"
        >
          <template #input>
            <van-uploader
              v-model="resume"
              @delete="
                (e, detail) => {
                  delImg(e, detail, 'resume');
                }
              "
              :after-read="
                (e) => {
                  afterRead(e, 'resume');
                }
              "
              multiple
            />
          </template>
        </van-field> -->
          <div style="margin: 16px" v-if="showBtn">
            <van-button round block type="info" native-type="submit">
              预览
            </van-button>
          </div>
        </van-form>
      </div>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-popup v-model="showMajor" position="bottom">
        <van-picker
          show-toolbar
          :columns="officeSelect2"
          @confirm="onConfirmMajor"
          @cancel="showMajor = false"
        />
      </van-popup>
      <van-popup v-model="showAddress" position="bottom">
        <van-picker
          value-key="title"
          show-toolbar
          :columns="addressColumns"
          @confirm="onConfirmAddress"
          @cancel="showAddress = false"
        />
      </van-popup>

      <van-popup v-model="showTime" position="bottom">
        <van-datetime-picker
          type="date"
          @confirm="onConfirmtime"
          @cancel="showTime = false"
          :min-date="minDate"
          v-model="currentDate"
        />
      </van-popup>
      <van-popup
        v-model="showTxt"
        position="center"
        style="width: 95%"
        closeable
        round
      >
        <div class="cns">
          <div class="title">承诺书</div>
          <div class="content" v-html="txt"></div>
        </div>
      </van-popup>
      <selAddress
        :level="level"
        :show="seladdressshow"
        @confirm="confirmaddress"
        ref="selAddressRef"
      ></selAddress>

      <van-popup
        v-model="dzShow"
        :style="{ width: '80%', 'max-height': '800px' }"
        closeable
        round
      >
        <div style="padding: 40px 20px">
          <div v-html="showTitle.content"></div>
        </div>
      </van-popup>

      <van-popup v-model="timeshow" round position="bottom">
        <van-datetime-picker
          v-model="currentDate2"
          type="date"
          title="选择毕业时间"
          :min-date="minDate2"
          :max-date="maxDate2"
          @confirm="confirm_date"
          @cancel="timeshow = false"
        />
      </van-popup>
      <div v-show="false">{{ showKey }}</div>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog, DatetimePicker } from "vant";
import axios from "axios";
import selAddress from "@/components/selAddress";
import applyEnrollCheck from "@/components/applyEnrollCheck";
import {
  political,
  marital,
  edu,
  sex,
  convertBase64UrlToBlob,
  specific,
  cardType,
} from "./data";

export default {
  data() {
    return {
      cityDz: [],
      officeDz: {},
      officeSelect: [],
      officeSelect2: [],
      officeSelect2026: [],

      currentDate2: new Date(2026, 0, 1),
      minDate2: new Date(1990, 0, 1),
      maxDate2: new Date(2026, 12, 31),
      timeshow: false,

      form: {
        id_card: "",
        card_type: "0",
        position_applied: "",
        edu: "",
        age: "",
      },
      sms: "",
      value: "",
      uploader: [],
      showPicker: false,
      showMajor: false,
      showAddress: false,
      showTime: false,
      currentDate: new Date(2000, 0, 1),
      minDate: new Date(1960, 0, 1),
      seladdressshow: false,
      showTxt: false,
      timeKey: "",
      key: "",
      address: "",
      fileList: [],
      other_certificate: [],
      skills_certificate: [],
      resume: [],
      cardnegative: [],
      piclink: [],
      diploma: [],
      cardpositive: [],
      test: "",
      is_checked: false,
      formList: [],
      showBtn: true,
      applyNumber: 0,

      showTitle: {},
      dzShow: false,
      appliedShow: 0,
      showKey: false,
      addressColumns: [],

      isPreview: 0,
    };
  },
  methods: {
    // 预览
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑动画
      });
    },
    backPreview(key) {
      this.isPreview = key;
      this.scrollToTop();
    },

    getCity() {
      this.cityDz = [];
      this.$api.getDz.page_city().then((res) => {
        if (res.code == 200) {
          let m = res.result;
          let cityId = this.$store.state.cityId;
          let n = m.findIndex((item) => {
            return item.id == cityId;
          });
          let cityItem = {};
          if (cityId != "" && n > 0) {
            cityItem = m[n];
          } else {
            cityItem = m[0];
          }
          // this.form.a_city = cityItem.title;
          this.$set(this.form, "a_city", cityItem.title);
          this.form.a_city_id = cityItem.id;
          this.getOffice(cityItem);
          this.appliedShow = cityItem.appliedShow;
          this.showKey = !this.showKey;
          // m.forEach((item) => {
          //   this.cityDz.push(item.title);
          //   this.getOffice(item);
          // });
        }
      });
    },
    getOffice(item) {
      this.$api.getDz.page_office({ id: item.id }).then((res) => {
        if (res.code == 200) {
          this.officeDz[item.title] = res.result;
        }
      });
    },
    getContent(id, key) {
      this.$api.getUser.get_agreement({ id: id }).then((res) => {
        if (res.code == 200) {
          this[key] = res.result;
          // if ((key = "showTitle")) {
          //   this.dzShow = true;
          // }
        } else {
          this.$toast.fail(res.result);
        }
      });
    },
    getAgeValue() {
      if (this.form.card_type && this.form.card_type != "0") {
        return;
      }
      this.$set(
        this.form,
        "birth",
        this.getBirthdayFromIdCard(this.form.id_card)
      );
      this.$set(
        this.form,
        "age",
        this.calculateAgeWithDays(this.getBirthdayFromIdCard(this.form.id_card))
      );
    },
    getDetail() {
      this.$api.getDz
        .getUserFormDetail({ city: this.$store.state.cityId })
        .then((res) => {
          try {
            if (Object.keys(res.result).length) {
              this.showBtn = false;
              let jsonKeys = [
                "other_certificate",
                "skills_certificate",
                "diploma",
                "piclink",
                "cardnegative",
                "cardpositive",
              ];
              jsonKeys.forEach((key) => {
                try {
                  if (res.result[key]) {
                    let val = res.result[key].split("@");
                    this[key] = [];
                    val.forEach((item) => {
                      let m = { url: item };
                      this[key].push(m);
                    });
                  } else {
                    res.result[key] = [];
                  }
                } catch (error) {}
              });
              console.log(888);

              this.address =
                res.result.province + res.result.city + res.result.area;
              this.form = { ...res.result };
              setTimeout(() => {
                this.formList.forEach((item) => {
                  let key = item.key;
                  if (this.form[key]) {
                    let parts = this.form[key].split("@");
                    item.yx = parts[0].replace("院校：", "");
                    item.zy = parts[1].replace("专业：", "");
                    item.xw = parts[2].replace("学位：", "");
                  }
                });
              });
            } else {
              this.getCity();
            }
          } catch (error) {
            console.log(error);
          }
        });
    },
    async onSubmit(e) {
      let jsonKeys = ["other_certificate", "skills_certificate", "diploma"];
      let params = { ...this.form };
      jsonKeys.forEach((key) => {
        try {
          if (params[key]) {
            params[key] = params[key].join("@");
          } else {
            params[key] = "";
          }
        } catch (error) {}
      });
      this.formList.forEach((item) => {
        params[
          item.key
        ] = `院校：${item.yx}@专业：${item.zy}@学位：${item.xw}@`;
      });

      let data = await this.$api.getDz.enroll_check2(params);
      if (data.code == 200) {
        this.isPreview = 1;
        this.scrollToTop();
        // let formData = {};
        // formData.form = this.form;
        // formData.formList = this.formList;
        // formData.address = this.address;
        // formData.appliedShow = this.appliedShow;
        // formData.applyNumber = this.applyNumber;
        // formData.piclink = this.piclink;
        // formData.cardpositive = this.cardpositive;
        // formData.cardnegative = this.cardnegative;
        // formData.diploma = this.diploma;
        // formData.skills_certificate = this.skills_certificate;
        // formData.other_certificate = this.other_certificate;
        // this.$store.commit("setApplyFormData", formData);
        // this.$router.push({ path: "/applyEnrollCheck" });
      }
    },
    onSubmitDz(e) {
      let jsonKeys = ["other_certificate", "skills_certificate", "diploma"];
      let params = { ...this.form };
      jsonKeys.forEach((key) => {
        try {
          if (params[key]) {
            params[key] = params[key].join("@");
          } else {
            params[key] = "";
          }
        } catch (error) {}
      });
      this.formList.forEach((item) => {
        params[
          item.key
        ] = `院校：${item.yx}@专业：${item.zy}@学位：${item.xw}@`;
      });
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: "报名信息一旦上传，无法修改，请各位考生谨慎填写",
        })
        .then(async () => {
          let data = await this.$api.getDz.postApply(params);
          if (data.code == 200) {
            this.$dialog
              .confirm({
                title: "提示",
                message: "您已报名成功，请留意资格审核状态!",
                showCancelButton: false,
              })
              .then(async () => {
                this.$router.go(-1);
              });
          }
        });
    },

    confirmaddress(vals) {
      this.seladdressshow = false;
      if (!vals.length) return;
      let keys = ["domicile", "native_place", "birthplace"];
      if (keys.includes(this.timeKey)) {
        this.$set(this.form, this.timeKey, vals.join(""));
        if (this.timeKey == "birthplace") {
          this.$set(this.form, "right_major", "");
          this.$set(this.form, "position_applied", "");
        }
      } else {
        let [province, city, area] = vals;
        this.form = { ...this.form, province, city, area };
        this.address = vals.join(" ");
      }
    },
    onConfirmtime(time) {
      let date = new Date(time);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = date.getDate();
      day = day < 10 ? "0" + day : day;
      let birthYear = year + "" + month + "" + day;
      birthYear = Number(birthYear);
      if (this.form.edu == "博士" && birthYear < 19810801) {
        this.$dialog
          .confirm({
            title: "提示",
            message:
              "根据招聘要求博士生出生日期1981年8月1日（含）后才可以报名,若具备副高及以上职称，请致电系统咨询电话进行人工处理",
            showCancelButton: false,
          })
          .then(async () => {});
        return;
      } else if (this.form.edu == "研究生" && birthYear < 19850806) {
        this.$dialog
          .confirm({
            title: "提示",
            message:
              "根据招聘要求研究生出生日期1985年8月6日（含）后才可以报名,若具备副高及以上职称，请致电系统咨询电话进行人工处理",
            showCancelButton: false,
          })
          .then(async () => {});
        return;
      } else if (this.form.edu == "本科" && birthYear < 19880801) {
        this.$dialog
          .confirm({
            title: "提示",
            message:
              "根据招聘要求本科生出生日期1988年8月1日（含）后才可以报名,若具备副高及以上职称，请致电系统咨询电话进行人工处理",
            showCancelButton: false,
          })
          .then(async () => {});
        return;
      }
      const formattedDate = year + "-" + month + "-" + day;
      this.$set(this.form, "birth", formattedDate);
      this.$set(this.form, "age", this.calculateAgeWithDays(formattedDate));
      this.showTime = false;
    },

    // 图片操作
    delImg(file, detail, key) {
      this.form[key].splice(detail.index, 1);
      this.$toast("删除成功");
    },
    // 单图片
    afterRead(file, key) {
      if (!this.form.key) {
        this.$set(this.form, key, []);
      }
      if (file && file.length > 0) {
        for (let i of file) {
          this.imgCompress(i.content, (src) => {
            this.form[key].push(src);
          });
        }
      } else {
        this.imgCompress(file.content, (src) => {
          this.$set(this.form, key, src);
        });
      }
    },
    // 多图片
    afterReadList(file, key) {
      if (!this.form[key]) {
        this.$set(this.form, key, []);
      }
      if (file && file.length > 0) {
        for (let i of file) {
          this.imgCompress(i.content, (src) => {
            this.form[key].push(src);
          });
        }
      } else {
        this.imgCompress(file.content, (src) => {
          this.form[key].push(src);
        });
      }
    },
    imgCompress(path, callback) {
      var img = new Image();
      img.src = path;
      Toast.clear();
      Toast.loading({
        mask: true,
        message: "上传中...",
        duration: 0,
      });
      // base64地址图片加载完毕后执行
      img.onload = () => {
        var newUrl = path;
        let file = convertBase64UrlToBlob(newUrl);
        var fd = new FormData();
        fd.append("file", file, "file_" + Date.parse(new Date()) + ".jpg");
        // fd.append("folder", 'product');

        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };

        axios.post("/api/common/upload/index/", fd, config).then((res) => {
          Toast.clear();
          if (res.data.code == 200) {
            if (typeof callback === "function") {
              //调用它，既然我们已经确定了它是可调用的
              callback(res.data.result);
              Toast.success("上传成功");
            }
            return true;
          } else {
            Toast.fail("上传失败");
            return false;
          }
        });
      };
    },

    onConfirm(val) {
      if (this.key == "a_city" && this.form[this.key] != val) {
        this.form.position_applied = "";
      } else if (this.key == "edu" && this.form[this.key] != val) {
        this.form.id_card = "";
        this.form.birth = "";
        this.form.age = "";
        this.eduFormList(val);
      }

      if (this.key == "card_type") {
        if (val == "澳门身份证") {
          this.form[this.key] = "2";
        } else if (val == "香港身份证") {
          this.form[this.key] = "1";
        } else {
          this.form[this.key] = "0";
        }
        this.form.id_card = "";
        this.form.birth = "";
        this.form.age = "";
      } else {
        this.$set(this.form, this.key, val);
      }

      this.showPicker = false;
    },
    onConfirmMajor(val, a) {
      if (val[0] == "2026本科") {
        this.$dialog
          .confirm({
            title: "温馨提示",
            message:
              "本岗位报考对象仅限 2026 年广东省生源的教育部直属师范大学公费师范毕业生，须具备本科学历及对应学士学位，且所学专业须符合本岗位明确指定的专业要求。请报考考生务必仔细核查个人生源身份、院校培养性质、学历学位信息及专业匹配度，确认完全符合上述所有条件后再行报考。",
          })
          .then(async () => {
            this.$set(this.form, "right_major", val[1]);
            this.showMajor = false;
          });
      } else {
        this.$set(this.form, "right_major", val[1]);
        this.showMajor = false;
      }
    },
    getOfficeSelect(text, key, type, item) {
      if (type == "officeSelect2026" && item.types == "非2026年毕业生") {
        this[type] = [];
      }
      let children = [];
      if (text != "") {
        let text2 = text.replaceAll("\n", "").replaceAll(" ", "");
        console.log(text2);
        let list = text2.match(/.+?[(（][A-Z0-9]+[)）]/g);
        console.log(list);
        list.forEach((item) => {
          let n = { text: item };
          children.push(n);
        });
        let m = {
          children: children,
          text: key,
        };
        this[type].push(m);
      }
    },
    onConfirmAddress(val) {
      if (this.form.position_applied != val.title) {
        this.form.right_major = "";
      }
      this.form.position_no = val.zwdm;
      this.form.position_applied = val.title;
      this.officeSelect = [];
      this.officeSelect2026 = [];
      this.getOfficeSelect(val.zydm_bk, "本科", "officeSelect");
      this.getOfficeSelect(val.zydm_yjs, "研究生", "officeSelect");
      this.getOfficeSelect(val.bk_26, "2026本科", "officeSelect2026", val);

      this.$api.getDz
        .getNumber({
          a_city: this.form.a_city,
          position_applied: this.form.position_applied,
        })
        .then((res) => {
          this.applyNumber = res.result;
        });
      this.showAddress = false;
    },
    confirm_date(date) {
      this.$set(
        this.form,
        "graduated_school_time",
        parseInt(date.getTime() / 1000)
      );

      this.$set(this.form, "right_major", "");
      this.$set(this.form, "position_applied", "");

      this.timeshow = false;
    },
    openPicker(key) {
      if (key == "毕业时间") {
        this.timeshow = true;
      } else if (key == "出生日期") {
        this.showTime = true;
      } else {
        this.key = key;
        this.showPicker = true;
      }
    },
    openAddress(key) {
      this.timeKey = key;
      this.$refs.selAddressRef.init();
      this.seladdressshow = true;
    },
    openMajor() {
      if (!this.form.position_applied) return this.$toast("请选择报考岗位");
      if (!this.form.edu) return this.$toast("请选择学历");
      if (!this.form.graduated_school_time)
        return this.$toast("请选择毕业时间");
      if (!this.form.birthplace) return this.$toast("请选择生源地");

      const date = new Date(this.form.graduated_school_time * 1000);
      let m = date.getFullYear();
      if (
        this.form.edu == "本科" &&
        m == "2026" &&
        this.form.birthplace.indexOf("广东省") != -1
      ) {
        this.officeSelect2 = [...this.officeSelect, ...this.officeSelect2026];
      } else {
        this.officeSelect2 = this.officeSelect;
      }
      this.showMajor = true;
    },
    openPosition() {
      if (!this.form.a_city) return this.$toast("请选择报考城市");
      this.addressColumns = this.officeDz[this.form.a_city];
      this.showAddress = true;
    },

    calculateAgeWithDays(birthDate) {
      const today = new Date();
      const birth = new Date(birthDate);
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birth.getDate())
      ) {
        age--;
      }

      return age;
    },
    getBirthdayFromIdCard(idCard) {
      let birthday = "";
      if (idCard.length === 18) {
        birthday =
          idCard.substring(6, 10) +
          "-" +
          idCard.substring(10, 12) +
          "-" +
          idCard.substring(12, 14);
      } else if (idCard.length === 15) {
        birthday =
          "19" +
          idCard.substring(6, 8) +
          "-" +
          idCard.substring(8, 10) +
          "-" +
          idCard.substring(10, 12);
      }
      return birthday;
    },
    eduFormList(edu) {
      this.$set(this.form, "right_major", "");
      this.$set(this.form, "position_applied", "");
      switch (edu) {
        case "本科":
          this.formList = [
            {
              key: "bachelor_degree",
              label: "本科",
              yx: "",
              zy: "",
              xw: "",
            },
          ];
          break;
        case "研究生":
          this.formList = [
            {
              key: "bachelor_degree",
              label: "本科",
              yx: "",
              zy: "",
              xw: "",
            },
            {
              key: "graduate_degrees",
              label: "研究生",
              yx: "",
              zy: "",
              xw: "",
            },
          ];
          break;
        case "博士":
          this.formList = [
            {
              key: "bachelor_degree",
              label: "本科",
              yx: "",
              zy: "",
              xw: "",
            },
            {
              key: "graduate_degrees",
              label: "研究生",
              yx: "",
              zy: "",
              xw: "",
            },
            {
              key: "doctoral_degrees",
              label: "博士",
              yx: "",
              zy: "",
              xw: "",
            },
          ];
          break;
        default:
          this.formList = [];
          break;
      }
    },

    //验证方法
    validatorCard(val) {
      return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val);
    },
    validatorCard1(val) {
      if (this.form.card_type && this.form.card_type != "0") {
        return true;
      }
      let birthYear = parseInt(val.substring(6, 14));
      if (this.form.edu != "本科") {
        return true;
      } else if (birthYear < 19880801) {
        return false;
      } else {
        return true;
      }
    },
    validatorCard2(val) {
      if (this.form.card_type && this.form.card_type != "0") {
        return true;
      }
      let birthYear = parseInt(val.substring(6, 14));
      if (this.form.edu != "研究生") {
        return true;
      } else if (birthYear < 19850806) {
        return false;
      } else {
        return true;
      }
    },
    validatorCard3(val) {
      if (this.form.card_type && this.form.card_type != "0") {
        return true;
      }
      let birthYear = parseInt(val.substring(6, 14));
      if (this.form.edu != "博士") {
        return true;
      } else if (birthYear < 19810801) {
        return false;
      } else {
        return true;
      }
    },
    validatorTel(val) {
      return /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(
        val
      );
    },

    isIn(key) {
      this.$api.getDz.enroll_entrance().then((res) => {
        if (res.code == 200) {
          let entrance = res.result || [];
          if (entrance[key] && entrance[key] != false) {
          } else {
            this.$store.commit("setRedirect", "");
            this.$router.push({ path: "/home" });
          }
        }
      });
    },
  },
  computed: {
    columns() {
      switch (this.key) {
        case "sex":
          return sex;
        case "political_status":
          return political;
        case "marital_status":
          return marital;
        case "edu":
          return edu;
        case "a_city":
          console.log(this.cityDz);

          return this.cityDz;
        case "specific_skill":
          return specific;
        case "card_type":
          return cardType;
        default:
          return [];
      }
    },
    level() {
      switch (this.timeKey) {
        case "native_place":
          return 2;
        case "domicile":
          return 2;
        case "birthplace":
          return 2;
        default:
          return 3;
      }
    },
    diplomaRules() {
      return [{ required: "onChange", message: "请上传学历证书" }];
    },
    skills_certificateRules() {
      return [{ required: "onChange", message: "请上传技能证书" }];
    },
    txt() {
      if (!this.form.position_applied) return "";
      let yw = "";
      let yy =
        this.form.position_applied.indexOf("英语") != -1
          ? `本人承诺在2024年8月31日前取得英语专业八级水平证书，或雅思考试成绩6.5分(含)以上或托福考试成绩90分(含) 以上(国、境外英语教育专业本科、研究生毕业除外)。`
          : "";
      let sz =
        this.form.position_applied.indexOf("思政") != -1
          ? `本人承诺在2024年8月31日前成为中共党员或中共预备党员。`
          : "";
      return `
      本人承诺在2024年8月31日前取得相应的学历和学位证书

      ${yy || sz || ""}

      本人承诺在2024年8月31日前取得相应层次 (种类)及以上的教师资格证

      我已详细阅读了招考公告、职位相关要求和填表说明，确信符合报考条件及职位要求。本人保证填报资料真实准确，如因个人填报信息失实或不符合报考条件和职位要求而被取消考录资格的，由本人负责。`
        .replace(/(\n|\r|\r\n|↵)/g, "<br/>")
        .replace(/\s/g, "&nbsp;");
    },
  },
  created() {
    this.isIn("考试报名入口");
    this.getDetail();
    if (this.$store.state.user.tel) {
      this.form.tel = this.$store.state.user.tel;
    }
  },
  components: {
    applyEnrollCheck,
    selAddress,
  },
};
</script>

<style lang="less">
.applyForm {
  background-color: rgba(204, 204, 204, 0.259);
  height: max-content;
  padding: 12px;
  /* padding-top: 60px; */
}
.applyForm .form_content {
  width: 100%;
  border-radius: 5px;
  overflow: auto;
}
.van-checkbox {
  height: max-content !important;
}
.cns {
  text-align: left;
  padding: 20px 10px;
  .title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    text-align: center;
  }
}
.van-ellipsis {
  white-space: normal !important;
  text-overflow: clip !important;
}
</style>
